'use client'
import { FC } from 'react'
import { useTranslations } from 'next-intl'
import { isNil } from 'lodash'

import { LoanStatusForm as LoanStatusFormEnum } from '../../../models/loanModels'
import Badge, { BadgeProps } from './Badge'

export interface LoanStatusProps {
    status: LoanStatusFormEnum | undefined
}

const LoanStatus: FC<LoanStatusProps> = ({ status }) => {
    const t = useTranslations('root')

    const resolveBadgeType = (): BadgeProps['intent'] => {
        switch (status) {
            case 'BLOCKED':
            case 'PAST_DUE':
            case 'PAYMENT_FAILED':
                return 'negative'

            case 'REPAID':
                return 'positive'

            case 'REFUSED':
            case 'CANCELED':
            case 'PAYMENT_CANCELED':
                return 'default'

            default:
                return 'information'
        }
    }

    return !isNil(status) ? (
        <Badge intent={resolveBadgeType()}>{t(`badges.${status.toLocaleLowerCase()}` as any)}</Badge>
    ) : null
}

export default LoanStatus
